import MobileCarouselComponent from './MobileCarousel.component';
export default MobileCarouselComponent;